import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    ApproveTaskDeliverablesInput,
    ArchiveTaskDeliverablesInput,
    ChangeTaskDeliverablesPathLocation,
    CreateTaskDeliverablesInput,
    RestoreTaskDeliverablesInput,
    TaskDeliverableFilterInput,
    UpdateTaskDeliverableInformationInput,
} from './inputs';
import { TaskDeliverableResource } from './resources';
import { TaskDeliverableRef, TaskDeliverableRefList } from './refs';

export default class TaskDeliverable {
    private basePath = '/api/task-deliverable';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of task deliverables
    get = async (filter: TaskDeliverableFilterInput): Promise<CollectionResource<TaskDeliverableResource, {}>> => {
        const query = qs.stringify({ ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);
        return data;
    };

    // Get single task deliverable
    getById = async (id: ID): Promise<TaskDeliverableResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);
        return data;
    };

    // Create multiple task deliverables
    createBatch = async (input: CreateTaskDeliverablesInput): Promise<TaskDeliverableRefList> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    update = async (id: ID, input: UpdateTaskDeliverableInformationInput): Promise<TaskDeliverableRef> => {
        const { data } = await this.http.patch(`${this.basePath}/${id}`, input);
        return data;
    };

    // Approve deliverables
    approveBatch = async (input: ApproveTaskDeliverablesInput): Promise<TaskDeliverableRefList> => {
        const { data } = await this.http.post(`${this.basePath}/approve`, input);
        return data;
    };

    // Archive deliverables
    archiveBatch = async (input: ArchiveTaskDeliverablesInput): Promise<TaskDeliverableRefList> => {
        const { data } = await this.http.post(`${this.basePath}/archive`, input);
        return data;
    };

    // Approve deliverables
    restoreBatch = async (input: RestoreTaskDeliverablesInput): Promise<TaskDeliverableRefList> => {
        const { data } = await this.http.post(`${this.basePath}/restore`, input);
        return data;
    };

    // Change location of multiple deliverables
    changePathLocation = async (input: ChangeTaskDeliverablesPathLocation): Promise<TaskDeliverableRefList> => {
        const { data } = await this.http.post(`${this.basePath}/move-path`, input);
        return data;
    };
}
